import { Injectable } from "@angular/core";
import { Observable, Subject } from "rxjs";
import { LinkInfoCircuit } from "../links-step.model";

/**
 * Serviço responsável pela emissão de eventos de remoção de links do diagrama.
 */
@Injectable({ providedIn: "root" })
export class LinkRemovalEventService {
    private readonly event$ = new Subject<Partial<LinkInfoCircuit>>();

    emit(payload: Partial<LinkInfoCircuit>): void {
        this.event$.next(payload);
    }

    getEventObservable(): Observable<Partial<LinkInfoCircuit>> {
        return this.event$.asObservable();
    }
}
